/**
 * @deprecated:
 */
export class KeyRestService {

    public static readonly $inject: string[] = ["$rest"];

    constructor(private $rest: qpmn.common.rest.IRestService) { }

    /**
     * @description 用户注册
     * @deprecated:
     * @returns 
     */
    public getKey(): angular.IPromise<qpmn.common.rest.IRestResponse<number>> {
        return this.$rest.http<number>("keyRestService", "getKey");
    }
}